export const addResultsFilter = {
    namespaced: true,

    state: {
        selectedTab: 'by-athlete',
        groupFilter: {
            selectedAlternativeUserId: null,
            selectedCrewId: null,
            selectedSquadId: null,
            selectedUserId: null
        }
    },

    getters: {
        getFilter(state) {
            return state.groupFilter;
        },

        selectedTab(state) {
            return state.selectedTab;
        },

        selectedAlternativeUserId(state) {
            return state.groupFilter.selectedAlternativeUserId;
        },

        selectedCrewId(state) {
            return state.groupFilter.selectedCrewId;
        },

        selectedSquadId(state) {
            return state.groupFilter.selectedSquadId;
        },

        selectedUserId(state) {
            return state.groupFilter.selectedUserId;
        }
    },

    mutations: {
        emptyGroupFilter(state) {
            Vue.set(state.groupFilter, 'selectedAlternativeUserId', null);
            Vue.set(state.groupFilter, 'selectedCrewId', null);
            Vue.set(state.groupFilter, 'selectedSquadId', null);
            Vue.set(state.groupFilter, 'selectedUserId', null);
        },

        selectTab(state, data) {
            state.selectedTab = data;
        },

        setSelectedAlternativeUserId(state, data) {
            state.groupFilter.selectedAlternativeUserId = data;
        },

        setSelectedCrewId(state, data) {
            state.groupFilter.selectedCrewId = data;
        },

        setSelectedUserId(state, data) {
            state.groupFilter.selectedUserId = data;
        },

        setSquad(state, data) {
            state.groupFilter.selectedSquadId = data;
        }
    },

    actions: {
        addScores(context, payload) {
            return context.dispatch(
                'post',
                {
                    url: `${api}session/${payload.id}/add-scores`,
                    data: payload.data
                },
                { root: true }
            );
        }
    }
};

export default addResultsFilter;
